"use client"

import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'

const GlitchText = ({ children }: { children: React.ReactNode }) => (
  <div className="glitch" data-text={children}>
    <h1 className="text-4xl font-bold text-white mb-6">
      {children}
    </h1>
  </div>
)

const LoadingBar = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(oldProgress => {
        const newProgress = oldProgress + Math.random() * 10
        return newProgress > 100 ? 100 : newProgress
      })
    }, 200)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="w-64 h-2 bg-gray-700 rounded-full overflow-hidden">
      <motion.div
        className="h-full bg-slate-100"
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.2 }}
      />
    </div>
  )
}

export default function Loading() {
  const [loadingText, setLoadingText] = useState('LOADING')

  const BackgroundLines = () => {
    const [lines, setLines] = useState<React.ReactNode[]>([])
    useEffect(() => {
      const newLines = [...Array(50)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute bg-slate-700"
          style={{
            width: Math.random() * 2 + 1,
            height: Math.random() * 10 + 5,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
          }}
          animate={{
            opacity: [0, 1, 0],
            height: ["5px", "20px", "5px"],
          }}
          transition={{
            duration: Math.random() * 2 + 1,
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
      ))
      setLines(newLines)
    }, [])
    return <>{lines}</>
  }

  useEffect(() => {
    const texts = ['LOADING']
    let index = 0
    const interval = setInterval(() => {
      index = (index + 1) % texts.length
      setLoadingText(texts[index])
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="h-screen bg-[var(--pr-bg-primary)] flex  flex-col items-center justify-center overflow-hidden fixed w-full z-[999999]">

      <motion.div
        className="text-center z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
          {loadingText}
        <LoadingBar />
        <p className="text-slate-700 mt-4 font-mono">initializing...</p>
      </motion.div>

      <BackgroundLines />
    </div>
  )
}

